import { render, staticRenderFns } from "./PlotReport.vue?vue&type=template&id=acffb8f0"
import script from "./PlotReport.vue?vue&type=script&lang=js"
export * from "./PlotReport.vue?vue&type=script&lang=js"
import style0 from "./PlotReport.vue?vue&type=style&index=0&id=acffb8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports